var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.99996L8.50001 13.5C8.10218 13.8978 7.87869 14.4374 7.87869 15C7.87869 15.5626 8.10218 16.1021 8.50001 16.5C8.89783 16.8978 9.4374 17.1213 10 17.1213C10.5626 17.1213 11.1022 16.8978 11.5 16.5L18 9.99996C18.7957 9.20432 19.2427 8.12518 19.2427 6.99996C19.2427 5.87475 18.7957 4.79561 18 3.99996C17.2044 3.20432 16.1252 2.75732 15 2.75732C13.8748 2.75732 12.7957 3.20432 12 3.99996L5.50001 10.5C4.30653 11.6934 3.63605 13.3121 3.63605 15C3.63605 16.6878 4.30653 18.3065 5.50001 19.5C6.69348 20.6934 8.31218 21.3639 10 21.3639C11.6878 21.3639 13.3065 20.6934 14.5 19.5L21 13",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.9cdca96c8f88abdcf8b0b6aeaa5cfabb.svg";
export { ForwardRef as ReactComponent };